import { Variable } from 'src/api/types';

/**
 * CRPD-7287 (I13) — Jennifer: "Variable IDs are shown in the audit not the variable name badge."
 *
 * Cost formulas are persisted in id-form (`#500001 * 2`), so the audit trail — which renders the
 * BE-authored action text verbatim — showed raw ids. Swap each `#<id>` for the variable's
 * alias/name so the entry is readable.
 *
 * Deliberately narrow: only `#` followed by digits is touched, so ordinary text (a control named
 * "#1 priority", a hex colour) is left alone. An id with no matching variable — deleted, or from
 * another workspace — keeps its raw token rather than blanking out, so no information is lost.
 */
export const resolveVariableTokens = (text: string, variables: Variable[] | null | undefined): string => {
  if (!text || !variables?.length) return text;

  return text.replace(/#(\d+)/g, (token, id: string) => {
    const variable = variables.find((candidate) => String(candidate.id) === id);
    if (!variable) return token;
    return variable.alias ?? variable.name;
  });
};
